import React from "react";
import { object } from "prop-types";

import { CenterColumn, LeftColumn, RightColumn } from "./columns";
import DfpContainer from "../../../ads/dfp-container";
import { DfpComponent } from "../../../ads/dfp-component";

import { componentProps, getSlotId } from "../../../utils/utils";
import { useDeviceType } from "../../../utils/react-utils";

import "./desktop-layout.m.css";

const DesktopLayout = ({ collection }) => {
  const { adSlot2, layoutName } = componentProps(collection);

  const { desktop } = useDeviceType();

  return (
    <div styleName="base">
      <div styleName="container">
        <LeftColumn collection={collection} />
        <CenterColumn collection={collection} />
        <RightColumn collection={collection} />
      </div>

      <DfpContainer styleName="b1-ad">
        {desktop && (
          <DfpComponent
            type={adSlot2}
            collectionSlug={collection.slug}
            slotId={getSlotId(adSlot2, collection.slug, 2)}
            layoutName={layoutName}
          />
        )}
      </DfpContainer>
    </div>
  );
};

DesktopLayout.propTypes = {
  collection: object,
};

export default DesktopLayout;
